import PropTypes from 'prop-types'
import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { SelectCustom } from '../../../../common/selectCustom'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { selectUserType } from '../../../../layout/store/slice'
import { USER_TYPE } from '../../../../utils/authorization'
import { Z_INDEX } from '../../../../utils/common'
import { changeTypeAlertDetail } from '../../detailsPortfolios/store/slice'
import { changeDataInRow, selectTypeAlert } from '../store/slice/slice'
import { putUpdateAlertProfile } from '../store/thunk'
import { CreateAlertProfile } from './CreateAlertProfile'

export const AlertProfile = ({
  isShow,
  setShow,
  rowId,
  data,
  colId,
  isDetail,
}) => {
  const dispatch = useDispatch()
  const datatype = useSelector(selectTypeAlert)
  const ref = useRef()

  const userType = useSelector(selectUserType)

  const [activeTypeAlert, setActiveTypeAlert] = useState(data)

  const handleSubmitChangeAlert = () => {
    dispatch(
      putUpdateAlertProfile({
        portfolioId: rowId,
        alertProfileId: activeTypeAlert.value,
      }),
    )
      .unwrap()
      .then(() => {
        if (!isDetail) {
          dispatch(
            changeDataInRow({
              rowId: rowId,
              colId: colId,
              value: activeTypeAlert.value,
            }),
          )
        }
        dispatch(changeTypeAlertDetail(activeTypeAlert))
      })
      .catch(() => {})
  }

  return (
    <PopupAction
      isShow={isShow}
      title="library.savePortfolio.ALERT_PROFILE"
      handleClose={() => setShow(false)}
      zIndexPopup={7}
      btnSubmit={{
        label: 'library.filterSetting.APPLY',
        event: () => {
          handleSubmitChangeAlert()
          setShow(false)
        },
        isI18n: true,
      }}
      btnCancel={{
        label: 'library.filterSetting.CANCEL',
        event: () => {
          setShow(false)
        },
        isI18n: true,
      }}
    >
      <div
        className="dFlex gap1 alignItemsCenter"
        style={{ paddingTop: '12px' }}
      >
        <div className="flex1" ref={ref}>
          <SelectCustom
            activeItem={activeTypeAlert}
            chooseItem={setActiveTypeAlert}
            isI18n
            data={datatype}
            style={{
              justifyContent: 'space-between',
              minHeight: '28px',
            }}
            labelOnBorder="library.savePortfolio.MESSAGE_ALERT_PORTFOLIO"
            zIndex={13}
          >
            {(onClickItem) => {
              return (
                <div
                  style={{ borderRadius: 2, width: ref?.current?.offsetWidth }}
                >
                  <ScrollComponent autoHeight autoHeightMax={400}>
                    {datatype.map((item) => (
                      <DropdownItems
                        key={item.value}
                        item={item}
                        onClick={() => {
                          onClickItem(item)
                        }}
                        isActive={activeTypeAlert?.value === item?.value}
                        disabled={!!item?.disabled}
                      />
                    ))}
                  </ScrollComponent>
                </div>
              )
            }}
          </SelectCustom>
        </div>

        {[USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(userType.userTypeId) && (
          <CreateAlertProfile setActiveTypeAlert={setActiveTypeAlert} />
        )}
      </div>
    </PopupAction>
  )
}

export const DropdownItems = ({ item, onClick, isActive, disabled }) => {
  const [bgColor, setBgColor] = useState('#F3F3F3')

  const onMouseEnter = () => {
    setBgColor('#E5F2FF')
  }

  const onMouseLeave = () => {
    setBgColor('#F3F3F3')
  }

  const onSelect = () => {
    if (disabled) return

    onClick()
  }

  return (
    <Element
      className="cursorPointer w100"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        backgroundColor: bgColor,
        cursor: disabled ? 'not-allowed' : 'default',
      }}
      onClick={onSelect}
    >
      <Element
        style={{
          color: disabled ? '#9C9C9C' : isActive ? '#2C73E8' : '#191D25',
          fontWeight: isActive ? 500 : 400,
          padding: '4px 8px',
        }}
      >
        <TextEllipsisStaticLine
          text={item.label}
          lineClamp={1}
          isI18n={item?.isI18n}
          zIndexTooltip={Z_INDEX.MODAL + 1}
        />
      </Element>
    </Element>
  )
}

AlertProfile.propsType = {
  isShow: PropTypes.bool,
  setShow: PropTypes.func,
  rowId: PropTypes.string,
  data: PropTypes.any,
  colId: PropTypes.any,
  isDetail: PropTypes.bool,
}

AlertProfile.defaultProps = {
  isDetail: false,
}
